import React from 'react';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@styled-icons/material-outlined';
import { StyledCollapseButton } from './NavBar.styles';

interface CollapseButtonProps {
  isCollapsed: boolean;
  onClick: () => void;
}

export const CollapseButton: React.FC<CollapseButtonProps> = ({ isCollapsed, onClick }) => {
  return (
    <StyledCollapseButton onClick={onClick}>
      {isCollapsed ? <KeyboardArrowRight size={16} /> : <KeyboardArrowLeft size={16} />}
    </StyledCollapseButton>
  );
};
